<template>
  <div class="icon-image-upload">
    <div class="upload-icon-wrapper">
      <feather-icon
        :title="$t('Upload Image')"
        icon="UploadIcon"
        svgClasses="size-15"
        class="upload-svg-icon text-white"
      ></feather-icon>
      <input
        type="file"
        @change="onFileChange"
        ref="file"
      >
    </div>
  </div>
</template>


<script>
import { uploadFile } from '@/api/storage'

export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    w: {
      type: Number,
      default: 400
    },
    h: {
      type: Number,
      default: 300
    },
    label: {
      type: String,
      default: ''
    },
    maxSize: {
      type: String,
      default: '1MB'
    },
    filename: {
      type: String,
      default: 'file'
    }
  },
  methods: {
    onFileChange () {
      var file = this.$refs.file.files[0]

      if (file) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Uploading file...',
          color: 'warning',
          icon: 'cloud_upload'
        })

        var fileExtension = file.name.split('.')

        uploadFile(`upload/${this.filename}-${Date.now()}.${fileExtension.pop()}`, file)
          .then(snapshot => {
            return snapshot.ref.getDownloadURL()
              .then((res) => {
                this.$emit('upload-success', res)
                this.notifySuccess('Image uploaded')
              })
          })
          .catch(err => {
            this.notifyError(err.msg)
          })
      }

    }
  }
}
</script>


<style lang="scss">
.icon-image-upload {
  &:hover {
    cursor: pointer;
  }
  .upload-icon-wrapper {
    position: relative;
    overflow: hidden;
    width: 25px;
    height: 25px;

    &:hover {
      cursor: pointer;
    }
    .upload-svg-icon {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      &:hover {
        cursor: pointer;
      }
    }

    input {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
